import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { categoryName } from "@/lib/api";

const AdminProducts = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/products");
            setItems(data);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => { load(); }, []);

    const remove = async (id) => {
        if (!window.confirm("Delete this product?")) return;
        try {
            await api.delete(`/products/${id}`);
            toast.success("Product deleted");
            load();
        } catch {
            toast.error("Delete failed");
        }
    };

    return (
        <div data-testid="admin-products-page">
            <div className="flex items-end justify-between mb-10">
                <div>
                    <div className="overline text-red-600 mb-3">Catalog</div>
                    <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl">Products</h1>
                </div>
                <Link to="/admin/products/new" className="btn-primary" data-testid="admin-new-product">
                    <Plus size={14} /> New Product
                </Link>
            </div>

            <div className="bg-white border border-gray-200">
                <div className="grid grid-cols-12 gap-4 p-5 border-b border-gray-200 font-mono text-[10px] uppercase tracking-[0.22em] text-gray-500">
                    <div className="col-span-1">Image</div>
                    <div className="col-span-4">Name</div>
                    <div className="col-span-3">Category</div>
                    <div className="col-span-2">Featured</div>
                    <div className="col-span-2 text-right">Actions</div>
                </div>
                {loading ? (
                    <div className="p-10 text-sm text-gray-500">Loading…</div>
                ) : items.length === 0 ? (
                    <div className="p-10 text-sm text-gray-500">No products yet.</div>
                ) : (
                    items.map((p) => (
                        <div key={p.id} className="grid grid-cols-12 gap-4 p-5 border-b border-gray-100 items-center" data-testid={`row-${p.slug}`}>
                            <div className="col-span-1">
                                <div className="w-14 h-14 bg-gray-100 border border-gray-200 overflow-hidden">
                                    {p.images?.[0] && <img src={p.images[0]} alt="" className="w-full h-full object-cover" />}
                                </div>
                            </div>
                            <div className="col-span-4">
                                <div className="font-medium">{p.name}</div>
                                <div className="text-xs text-gray-500 font-mono">{p.slug}</div>
                            </div>
                            <div className="col-span-3 text-sm text-gray-600">{categoryName(p.category)}</div>
                            <div className="col-span-2 text-sm">
                                {p.featured ? <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-red-600">Featured</span> : <span className="text-gray-400">—</span>}
                            </div>
                            <div className="col-span-2 flex justify-end gap-2">
                                <Link to={`/admin/products/${p.id}/edit`} className="p-2 hover:bg-gray-100" data-testid={`edit-${p.slug}`}><Pencil size={16} /></Link>
                                <button onClick={() => remove(p.id)} className="p-2 hover:bg-gray-100 text-red-600" data-testid={`delete-${p.slug}`}><Trash2 size={16} /></button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AdminProducts;
